import React from 'react';
import { Alert, Button, Stack, TextField, Typography } from '@mui/material';
import { PlayerCardLayout } from '../../components/PlayerCardLayout';
import { useT } from '../../localization/LocalizationProvider';

function ProjectFooter() {
  return (
    <div
      style={{
        textAlign: 'center',
        borderTop: '1px solid #ccc',
        paddingTop: '15px',
        marginTop: '16px'
      }}
    >
      <img
        src="/portals/0/UNIQA.png"
        style={{ display: 'inline-block' }}
        width="190"
        alt="UNIQA"
      />
      <p style={{ marginBottom: 0, paddingTop: '10px', paddingBottom: '0px' }}>
        Financijska igra i Escape Room izazov
      </p>
      <a href="/o-projektu" style={{ color: '#5174dd' }}>
        &gt; Saznaj više o projektu &lt;
      </a>
    </div>
  );
}

export function IntroPage({ sessionStatus, header, name, setName, onJoin, joining, error, canJoin, joinBlockedReason, isResetState = false }) {
  const t = useT();

  return (
    <PlayerCardLayout header={header}>
      {isResetState ? (
        <Alert severity="info">
          {t('Player.Intro.ResetMessage')}
        </Alert>
      ) : (
        <>
          <Typography>{sessionStatus?.introText || t('Player.Intro.WelcomeFallback')}</Typography>
          <Typography>{t('Player.Intro.PlayersLabel', { value: sessionStatus?.joinedDisplay || '0/0' })}</Typography>
          <Typography variant="body2" color="text.secondary">
            {t('Player.Intro.PlayersSummary', { joined: sessionStatus?.joinedCount ?? 0, enabled: sessionStatus?.enabledPlayersCount ?? 0 })}
          </Typography>

          {canJoin ? (
            <>
              <TextField fullWidth label={t('Player.Intro.NameLabel')} value={name} onChange={(event) => setName(event.target.value)} />
              <Stack direction="row" spacing={2}>
                <Button variant="contained" disabled={joining} onClick={onJoin}>{t('Buttons.Start')}</Button>
              </Stack>
            </>
          ) : (
            <Alert severity="warning">{joinBlockedReason || t('Player.Intro.JoinUnavailable')}</Alert>
          )}

          {error && <Alert severity="error">{error}</Alert>}
        </>
      )}

      <ProjectFooter />
    </PlayerCardLayout>
  );
}